import styled from 'styled-components'

export const FeatureWrapper = styled.div `
    position: relative;
`; 